export default "__VITE_ASSET__D6kOlW0b__"